import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '@/lib/api';
import { useAuth } from '@/context/AuthContext';

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (done.current) return;
    done.current = true;

    const hash = window.location.hash || '';
    const params = new URLSearchParams(hash.replace(/^#/, ''));
    const sessionId = params.get('session_id');
    if (!sessionId) { nav('/login', { replace: true }); return; }

    (async () => {
      try {
        const { data } = await api.post('/auth/emergent-session', { session_id: sessionId });
        if (data.token) localStorage.setItem('ls_token', data.token);
        setUser(data.user);
        // Clean up URL and route to dashboard
        window.history.replaceState({}, '', '/dashboard');
        nav('/dashboard', { replace: true, state: { user: data.user } });
      } catch (e) {
        setError('Sign-in failed. Please try again.');
        setTimeout(() => nav('/login', { replace: true }), 1500);
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#111111] text-white">
      <div className="text-center">
        <div className="mx-auto h-10 w-10 rounded-full border-2 border-white/10 border-t-brand animate-spin" />
        <div className="mt-4 text-white/60 text-sm">{error || 'Completing sign-in…'}</div>
      </div>
    </div>
  );
}
